import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section className="pt-5 bg-light">
      {/* Banner principale */}
      <div className="container py-5">
        <div className="row align-items-center g-4">
          <div className="col-lg-6">
            <span className="badge bg-primary bg-opacity-10 text-primary mb-3 fw-semibold">CASA EDITRICE INDIPENDENTE</span>
            <h1 className="display-5 fw-bold mb-3">Dove i libri mettono radici</h1>
            <p className="lead text-muted mb-4">
              Bookolica è una casa editrice indipendente che coltiva storie genuine 
              e trasformative, radicate nella bellezza della parola scritta.
            </p>
            <div className="d-flex flex-wrap gap-2">
              <a href="#il-libro" className="btn btn-primary">
                Scopri il libro
              </a>
              <a href="#chi-siamo" className="btn btn-outline-primary">
                Chi siamo
              </a>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="d-flex justify-content-center">
              <div className="card border-0 shadow" style={{maxWidth: '350px'}}>
                <div className="card-img-top bg-primary bg-gradient text-white p-4 ratio ratio-3x4">
                  <div className="d-flex flex-column justify-content-center align-items-center h-100 text-center">
                    <span className="small text-uppercase text-white-50 mb-2">Novità</span>
                    <h3 className="fs-2 fw-bold mb-2">Dove i libri<br/>mettono radici</h3>
                    <hr className="opacity-25 w-25 mx-auto my-3" />
                    <div className="fs-5">Silio</div>
                  </div>
                </div>
                <div className="card-body text-center">
                  <span className="fw-bold text-primary fs-5">€9,90</span>
                  <a 
                    href="https://bookolica.gumroad.com/l/doveilibrimettonoradici" 
                    className="btn btn-light d-block mt-3"
                  >
                    Acquista ora
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 